export const visit = (vm, at) => {
at({ "fr": { "priceComponents": { "pricePerMonth": "{{price}}/mois", "pricePerMonthPerSeat": "{{price}}/mois/licence", "pricingLabel": "Tarifs {{name}}", "subtexts": { "startsAt": "\xC0 partir de" } } } });
};